import * as React from "react"
import { gsap } from "gsap";
import Title from "../components/Title" 
import { GatsbyImage } from "gatsby-plugin-image" 

class IntroAnimation extends React.Component {
  preloader() {
    console.log('start animation');
  }
  animation() {
    if(window.innerWidth<768) {
      var width = '150%'
    } else {
      width = '100%'
    }
    var tl = gsap.timeline(); 
    tl.to(".preloader", {opacity: 0, duration: .25}); 
    tl.to(".image--container", {opacity: 1, delay:.25, duration: .75});
    tl.to(".image--container .fourth", {duration: .5, opacity:1, ease: "power2.out", onComplete:function(){
      setTimeout(function(){ 
        document.querySelector('.introduction--container .title--animation').classList.add('is-inview');
        document.querySelector('.preloader').style.opacity='';
      }, 1750); 
    }});
    tl.to(".image--container .images", {width: width, height:'100%', top:'50%', duration: 2, ease: "power3.inOut"}); 
    tl.to(".masthead", {duration: .5, delay:.5, opacity:1, ease: "power2.out"});
  }
  render() {  
    return ( 
      <div className="introduction--container h-125 intro-100vh flex flex-wrap">
        <div className="align-self--top mt80 w-100 pt50 ma">
          <Title Line1="Embrace" Line2="A New" Line3="Reality" />
        </div>
        <div className="introduction-copy medium m-small fade-in" data-scroll> 
          <div className="introduction--copy">
            {this.props.introduction} 
          </div>
        </div>
        <div className="image--container">
            <div className="images"> 
              <div className="inner">
                <div className="fourth image">
                  <div className="video-container">
                    <GatsbyImage image={this.props.image} onLoad={() =>{this.animation()}} alt="Introduction Image" className="bg-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    )
  }
} 

export default IntroAnimation

 